import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import type { PartialEntityData } from '@adornis/baseql/entities/types.js';

/**
 * Per-user dashboard preferences, keyed by the AdornisUser `_id`. Kept as a
 * separate collection (rather than extending AdornisUser) to avoid touching the
 * framework user entity.
 */
@Entity()
export class UserPreferences extends MongoEntity {
  static override _class = 'UserPreferences';
  static override _collectionName = 'user-preferences';

  @Field(() => String) userID!: string;

  /**
   * Whether open questions about this user's forwarded requests are mailed back to them.
   *
   * Defaults to **on**, unlike the opt-in validation reply it replaced. That one was an
   * extra: a copy of what the dashboard showed anyway. This is the channel that reaches
   * someone who forwards a request and turns back to their inbox — off by default it would
   * silently never arrive, and the question would wait for a dashboard visit that may never
   * come.
   */
  @Field(() => Boolean, { default: (v: any) => v ?? true }) receiveQuestionMails: Maybe<boolean>;

  constructor(doc: PartialEntityData<UserPreferences>) {
    super(doc);
  }
}
